import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Icon from "../components/Icon";
import ManifestStrip from "../components/ManifestStrip";
import { services, whyChooseUs } from "../data/content";

export default function Services() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: "Logistics and Freight Forwarding",
    provider: {
      "@type": "Organization",
      name: "PT. Bumi Cakrawala Logistik",
    },
    areaServed: "ID",
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Logistics Services",
      itemListElement: services.map((s) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: s.title,
          description: s.description,
        },
      })),
    },
  };

  return (
    <>
      <Seo path="/services" jsonLd={jsonLd} />

      <header className="page-hero">
        <div className="page-hero__bg">
          <img src="/images/truck-tunnel.jpg" alt="Freight truck moving through an elevated concrete corridor" />
        </div>
        <div className="container page-hero__inner">
          <span className="page-hero__crumb">
            <Link to="/">Home</Link> / Services
          </span>
          <h1>Our Services</h1>
          <p>
            End-to-end freight forwarding, customs, warehousing, and project cargo
            solutions — engineered to keep your supply chain moving, on time and in
            full.
          </p>
        </div>
      </header>

      <ManifestStrip label="SERVICE LINES" lanes={services.map((s) => s.code + " \u2014 " + s.title.toUpperCase())} />

      <section className="section">
        <div className="container">
          <div className="services-grid">
            {services.map((s) => (
              <article className="service-card" key={s.code}>
                <div className="service-card__image">
                  <img src={s.image} alt={s.title} />
                </div>
                <div className="service-card__body">
                  <div className="service-card__top">
                    <div className="service-card__icon">
                      <Icon name={s.icon} />
                    </div>
                    <span className="service-card__code">{s.code}</span>
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">The Bumi Difference</span>
            <h2>Why Choose Us?</h2>
          </div>
          <div className="why-grid">
            {whyChooseUs.map((w) => (
              <div className="why-card" key={w.number}>
                <span className="why-card__num">{w.number}</span>
                <h3>{w.title}</h3>
                <p>{w.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--tight">
        <div className="container">
          <div className="cta-banner">
            <h2>Need a tailored logistics solution?</h2>
            <Link to="/contact" className="btn btn-dark">
              Request a Quote <Icon name="arrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
